// import axios from 'axios';
import React, { useEffect, useState } from "react";
import Modal from 'olive-react-myoneui/lib/Modal';
import Button from 'olive-react-myoneui/lib/Button';
import { API_URL, bulkEnrollModuleName, regularExpressions } from "../../../constants/config";
import { clockIcon, closeIcon, exclamatoryIcon, geoMarkIcon, learnerEdiIcon, learnerTrashIcon, multipleSessionIcon, orderSuccess, rssIcon } from "../../../constants/icons";
import { Form } from "olive-react-myoneui";
import { getBulkConfigs, getAllCourses } from "../../../api/initialApis";
import DropdownCommon from "../DropdownCommon";
import { getCache } from "../../Page/utils/cacheManager";
import { useNavigate } from 'react-router-dom';
import { useSelector } from "react-redux";
import { shortMonths, timeZoneList } from "../../../constants/timeZoneList";
import { countryList } from "../../../constants/countryList";
import { countryCodeList } from "../../../constants/countryCodeList";
import { useTranslation } from "react-i18next";
import useLangInit from "../../../hooks/useLangInit";

function BulkEnroll({ id, type }) {
  useLangInit(bulkEnrollModuleName);
  const { t } = useTranslation(bulkEnrollModuleName);
  const miscellaneous = useSelector(state => state.user.miscellaneous);
  const loggedInUser = useSelector(state => state.user.user.logged_in_user.user);
  const enrolled = useSelector(state => state.user.user.logged_in_user.enrolled);
  const paths = useSelector(state => state.user.paths);
  const navigate = useNavigate();
  if (!miscellaneous.bulk_purchase && enrolled[type].includes(id) || loggedInUser === false && !miscellaneous.guest_checkout) {
    navigate("/course/listing");
  }
  const [isWaitingList, setIsWaitingList] = useState(false);
  const [toast, setToast] = useState(false);
  const [currentLearnerDetails, setCurrentLearnerDetails] = useState({});
  const [editingLearnerKey, setEditingLearnerKey] = useState(false);
  const [totalLearnersList, setTotalLearnersList] = useState({});
  const [bulkConfigs, setBulkConfigs] = useState(false);
  const [actionButtonDisabled, setActionButtonDisabled] = useState(false);
  const [serverErrorShowAddLearner, setServerErrorShowAddLearner] = useState(false);
  const [serverErrorShowAddLearnerMobile, setServerErrorShowAddLearnerMobile] = useState(false);
  const [currentCountryCode, setCurrentCountryCode] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [orderModalShow, setOrderModalShow] = useState(false);
  const [subscriptionSuccessModalShow, setSubscriptionSuccessModalShow] = useState(false);
  const [subscriptionErrorMessage, setSubscriptionErrorMessage] = useState(false);
  const [placeOrderButtonDisabled, setPlaceOrderButtonDisabled] = useState(true);
  const [currentCourse, setCurrentCourse] = useState(null);
  const selectedTimeZone = timeZoneList[localStorage.getItem("selected_timezone") ? localStorage.getItem("selected_timezone") : miscellaneous.configured_time_zone];
  const offsetDifference = selectedTimeZone.utc_offset_seconds * 1000; // converting minutes to milli seconds
  const [hasPps, setHasPps] = useState(true);
  const [bulk_info_unavailable, setBulkInfoUnavailable] = useState(false);
  const [validated, setValidated] = useState(false);
  const [validatedPlaceOrder, setValidatedPlaceOrder] = useState(false);
  const [validationState, setValidationState] = useState({});
  const [validationStatePlaceOrder, setValidationStatePlaceOrder] = useState({});
  const [showItemList, setShowItemList] = useState(false);
  const [selectedEventIds, setSelectedEventIds] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedValueDetail, setselectedValueDetail] = useState(false);
  const [openDropdownCourseId, setOpenDropdownCourseId] = useState(null);
  const [selectedEventDetails, setSelectedEventDetails] = useState({});

  // const currentCurrencySymbol = miscellaneous.current_currency.symbol;
  const currentTimeStamp = new Date(miscellaneous.current_date + " " + miscellaneous.current_time).getTime() + offsetDifference
  const clearErrors = () => {
    setValidated(false);
    document.querySelectorAll(".error-border").forEach(currentElement => currentElement.classList.remove("error-border"));
  }
  const clearLearnerDetails = () => {
    if (document.querySelector("#bulk_learner_name[readonly]")) {
      document.querySelectorAll(".bulk-learner-modal input:not(#bulk_learner_email)").forEach(elem => {
        elem.setAttribute('value', '');
        elem.value = '';
        elem.removeAttribute('readonly');
      });
      setHasPps(true);
      setBulkInfoUnavailable(false);
      setServerErrorShowAddLearner(false);
      setServerErrorShowAddLearnerMobile(false);
      setToast(false);
      setCurrentCountryCode("");
      clearErrors();
      setCurrentLearnerDetails({ bulk_learner_email: document.getElementById("bulk_learner_email") ? document.getElementById("bulk_learner_email").value : "", formReset: "addLearnerForm", "hasPps": true, "bulk_info_unavailable": false });
    }
  }

  function ErrorMessage({ id, errorMessage = "" }) {
    if (!validated) {
      return false;
    }
    if (validationState[id]) {
      errorMessage = validationState[id];
      return <>
        <div className="error-msg" id={"error_" + id}>
          <span className="error-msg-icon">
            {exclamatoryIcon}
          </span>
          {errorMessage}
        </div>
      </>
    }
    return false;
  }

  function ServerErrorOnAddLearnerEmail() {
    if (!serverErrorShowAddLearner) {
      return false;
    }
    const currentElement = document.getElementById("bulk_learner_email");
    if (currentElement) {
      currentElement.classList.add("error-border");
      miscellaneous.bulk_purchase && currentElement.removeAttribute("readonly");
    }
    return <>
      <div className="error-msg" id={"server_error_email"}>
        <span className="error-msg-icon">
          {exclamatoryIcon}
        </span>
        {serverErrorShowAddLearner}
      </div>
    </>
  }

  function ServerErrorOnAddLearnerMobile() {
    let currentFilledPhoneNum = "";
    if (document.getElementById("bulk_learner_phone_code")) {
      currentFilledPhoneNum = (document.getElementById("bulk_learner_phone_code").value + document.getElementById("bulk_learner_phone").value).replace("+", "");
    }
    if (!serverErrorShowAddLearnerMobile || currentFilledPhoneNum == "") {
      return false;
    }
    const currentElement = document.getElementById("bulk_learner_phone");
    if (currentElement) {
      currentElement.classList.add("error-border");
      currentElement.removeAttribute("readonly");
    }
    return <>
      <div className="error-msg" id={"server_error_email"}>
        <span className="error-msg-icon">
          {exclamatoryIcon}
        </span>
        {serverErrorShowAddLearnerMobile}
      </div>
    </>
  }

  function ErrorMessagePlaceOrder({ id, errorMessage = "" }) {
    if (!validatedPlaceOrder) {
      return false;
    }
    if (validationStatePlaceOrder[id]) {
      errorMessage = validationStatePlaceOrder[id];
      return <>
        <div className="error-msg" id={"error_" + id}>
          <span className="error-msg-icon">
            {exclamatoryIcon}
          </span>
          {errorMessage}
        </div>
      </>
    }
    return false;
  }

  function HelpText({ id, helpText = "" }) {
    if (!helpText) {
      return false;
    }
    if (validationState[id]) {
      return false;
    }
    return <>
      <div className="help-text" id={"help_text_" + id}>
        {helpText}
      </div>
    </>
  }
  const setLearnerDetails = (learner, onload = false) => {
    if (!document.getElementById("bulk_learner_email")) {
      setTimeout(() => {
        setLearnerDetails(learner, onload);
      }, 50);
      return false;
    }
    clearErrors();
    if (editingLearnerKey) {
      setServerErrorShowAddLearner(false);
      setServerErrorShowAddLearnerMobile(false);
      setCurrentLearnerDetails({
        hasPps: true,
        bulk_info_unavailable: false
      });
      setValidated(false);
      setHasPps(true);
      setBulkInfoUnavailable(false);
      setValidatedPlaceOrder(false);
    }
    let disabledFields = [];
    let currentLearnerObject = {bulk_learner_email: learner.us_email, hasPps: true};
    let setObject = {
      'us_name': "bulk_learner_name",
      'us_country_code': "bulk_learner_phone_code",
      'us_phone': "bulk_learner_phone",
      'id': "user_id"
    }
    if (!miscellaneous.bulk_purchase && loggedInUser) {
      setObject['us_email'] = "bulk_learner_email";
    }
    Object.keys(setObject).map(dbName => {
      const selectedElement = document.querySelector(`#${setObject[dbName]}`);
      currentLearnerObject[setObject[dbName]] = learner[dbName];
      if (selectedElement) {
        if (learner[dbName]) {
          selectedElement.value = learner[dbName];
          selectedElement.setAttribute('value', learner[dbName]);
          selectedElement.setAttribute('readonly', true);
          disabledFields.push(setObject[dbName]);
          if (selectedElement.id == "bulk_learner_phone_code") {
            setCurrentCountryCode(learner[dbName]);
          }
        }
      }
    });
    Object.keys(learner._dynamic).length > 0 && Object.keys(learner._dynamic).forEach(dynKey => {
      const dynamicCurrentElement = document.getElementById(dynKey);
      if (dynamicCurrentElement) {
        dynamicCurrentElement.setAttribute('value', learner._dynamic[dynKey]);
        dynamicCurrentElement.value = learner._dynamic[dynKey];
        currentLearnerObject[dynKey] = learner._dynamic[dynKey];
      }
      if (document.querySelector(`.custom_drop_down_value_${dynKey}`)) {
        currentLearnerObject[dynKey] = { name: learner._dynamic[dynKey], value: learner._dynamic[dynKey] };
      }
      if (dynKey === 'organisation' && document.getElementById('bulk_organisation')) {
        dynKey = 'bulk_organisation';
        document.getElementById(dynKey).setAttribute('value', learner._dynamic[`organisation_id`]);
        document.getElementById(dynKey).value = learner._dynamic[`organisation_id`];
        currentLearnerObject[dynKey] = {name: learner._dynamic[`organisation`], value: learner._dynamic[`organisation_id`]};
      }
    })
    currentLearnerObject["disabledFields"] = disabledFields;
    setCurrentLearnerDetails(currentLearnerObject);
    if (onload) {
      document.getElementById("actionButton").click()
    }
  }

  const customInputChange = (key, object) => {
    document.querySelectorAll(".custom_drop_down_value_" + key).forEach(element => {
      element.value = object.value;
      setCurrentLearnerDetails(state => {
        let currentLearnerState = { ...state };
        currentLearnerState[element.id] = object;
        return currentLearnerState;
      })
    });
  }

  const getLearnerDetails = async (inputEmail, onload = false) => {
    inputEmail = inputEmail.trim();
    if (inputEmail === "") {
      clearLearnerDetails();
      return false;
    }
    const formData = new FormData();
    formData.append(`learner[email]`, inputEmail);
    const apiResponse = await fetch(`${API_URL}cart_react/validate_learner`, {
      method: 'POST',
      body: formData
    }).then(res => {
      setActionButtonDisabled(false);
      return res.json();
    });
    if (+apiResponse.data?.id > 0) {
      setHasPps(true);
      setBulkInfoUnavailable(false);
      setLearnerDetails(apiResponse.data, onload);
    } else {
      clearLearnerDetails();
    }
  }

  const customInput = (e) => {
    const element = e.target;
    if (element.type == "tel") {
      element.value = element.value.replace(/[^0-9\+]/g, "");
    }
    if (element.id === "bulk_learner_phone_code") {
      setCurrentCountryCode(element.value);
    }
    setCurrentLearnerDetails(state => {
      let currentLearnerState = { ...state };
      currentLearnerState[element.id] = element.value;
      return currentLearnerState;
    });
    if (element.id === "bulk_learner_email") {
      setActionButtonDisabled(true);
      clearTimeout(window['emailSearchTimer']);
      window['emailSearchTimer'] = setTimeout(() => {
        getLearnerDetails(element.value);
      }, 1000);
    }
  }

  const customInputGuest = (e) => {
    const element = e.target;
    if (element.type == "tel") {
      element.value = element.value.replace(/[^0-9\+]/g, "");
    }
    element.setAttribute("value", element.value);
  }

  const css_api = async () => {
    return await fetch(`${API_URL}api/front_end/cart_css`)
    .then(response=>response.text())
    .then(response =>
    {return(response)})
  }
  const asyncAPICalls = async () => {
    const responseBulkConfigs = await getBulkConfigs();
    setBulkConfigs(responseBulkConfigs.data);
    let responseCurrentCourse = await getCache("all_courses", getAllCourses, {}, 2592000);
    responseCurrentCourse = responseCurrentCourse.filter(course => course.item_id == id && course.item_type == type);
    if (!responseCurrentCourse[0]) {
      navigate('/course/listing?debug=1' + `&course=${id}&type=${type}`);
      return false;
    }
    let course = responseCurrentCourse[0];
    const free = course.item_is_free == '1';
    const self_enroll = course.item_self_enroll === undefined ? true : (course.item_self_enroll == "0" ? false : (course.item_self_enroll_date === null ? true : (new Date(course.item_self_enroll_date).getTime() >= new Date(miscellaneous.current_date).getTime())) );
    const waitingList = ["booking_event"].includes(type) && typeof course.item_availability_seats != "undefined" && course.item_availability_seats < 1 && course.item_waiting_list == "1";
    setIsWaitingList(waitingList);
    if (!(self_enroll && (free || waitingList))) {
      navigate("/course/listing?debug=2");
      return false;
    }
    let imagePath = course.item_full_image;
    let defaultImage = "";
    let registration_started = true;
    let registration_ended = false;
    let free_button_index = "free_button";
    let free_label_index = "free_label";
    switch (type) {
      case 'course':
        defaultImage = paths.default_course;
      break;
      case 'bundle':
        defaultImage = paths.default_bundle;
      break;
      case 'blended':
        defaultImage = paths.default_course;
      break;
      case 'online':
        defaultImage = paths.default_course;
      break;
      case 'booking_event':
        defaultImage = paths.default_event;
        registration_started = currentTimeStamp >= new Date(course.item_reg_start_time).getTime() + offsetDifference;
        registration_ended = currentTimeStamp >  new Date(course.item_reg_end_time).getTime() + offsetDifference;
        free_button_index = "event_free_button";
        free_label_index = "event_free_label";
      break;
      case 'offline':
        defaultImage = paths.default_course;
      break;
      default:
        defaultImage = paths.default_course;
      break;
    }
    const registration_status = course.item_enable_disable_reg === undefined ? true : course.item_enable_disable_reg == "1" && registration_started && !registration_ended;
    const subscription_status = course.item_b2b_imported === undefined ? true : course.item_b2b_imported == "0" || (course.item_b2b_imported == "1" && course.item_no_of_subscriptions > course.item_enrolled_learners_count);
    if (!(registration_status && subscription_status)) {
      navigate("/course/listing?debug=3");
      return false;
    }
    course.item_full_image = imagePath;
    course.item_full_default_path = defaultImage;
    course.item_free_button = waitingList ? 'add_to_waiting_list' : miscellaneous[free_button_index];
    course.item_free_label = course.item_price_label_show == "1" ? miscellaneous[free_label_index] : "";
    let time_text = "";
    let single_day_event = true;
    if (["booking_event"].includes(type)) {
      let start_date = new Date(new Date(course.item_start_date + " " + course.item_start_time).getTime() + offsetDifference);
      let end_date = new Date(new Date(course.item_end_date + " " + course.item_end_time).getTime() + offsetDifference);
      single_day_event = ("0" + start_date.getDate()).substr(-2) + ("0" + start_date.getMonth()).substr(-2) + start_date.getFullYear() == ("0" + end_date.getDate()).substr(-2) + ("0" + end_date.getMonth()).substr(-2) + end_date.getFullYear();
      let hour = start_date.getHours();
      let ampm = "AM";
      if (hour >= 12) {
        ampm = "PM";
        if (hour > 12) {
          hour -= 12;
        }
      }
      time_text = `${!single_day_event ? `${("0" + start_date.getDate()).substr(-2)} ${shortMonths[start_date.getMonth()]} ` : ''}${("0" + hour).substr(-2)}:${("0" + start_date.getMinutes()).substr(-2)} ${ampm} - `;
      hour = end_date.getHours();
      ampm = "AM";
      if (hour >= 12) {
        ampm = "PM";
        if (hour > 12) {
          hour -= 12;
        }
      }
      time_text += `${!single_day_event ? `${("0" + end_date.getDate()).substr(-2)} ${shortMonths[end_date.getMonth()]} ` : ''}${("0" + hour).substr(-2)}:${("0" + end_date.getMinutes()).substr(-2)} ${ampm}`;
    }
    course.item_time_text = time_text;
    setCurrentCourse(course);
  }

  useEffect(() => {
    css_api()
    .then(response => {
      let newElem = document.createElement("style");
      newElem.innerHTML = response;
      document.getElementsByTagName("head")[0].appendChild(newElem);
    });
    asyncAPICalls();
    const scripts = ["assets/pseudo_files/geolocation.js"];
    scripts.forEach(script_src => {
      let script = document.createElement('script');
      script.src = API_URL + script_src;
      document.body.appendChild(script);
      return () => {
        document.body.removeChild(script);
      }
    });
  }, []);

  const addLearner = () => {
    let mainErrorStatus = false;
    let localValidationState = {};
    setValidated(false);
    setServerErrorShowAddLearner(false);
    setServerErrorShowAddLearnerMobile(false);
    setTimeout(() => {
      let validationObject = {
        bulk_learner_name: {
          key: 'bulk_learner_name',
          required: true,
          regex: regularExpressions.name,
          reqiredError: t('full_name') + t('_is_required'),
          regexError: t('full_name') + " " + t('containing_special_character')
        },
        bulk_learner_email: {
          key: 'bulk_learner_email',
          required: true,
          regex: regularExpressions.email,
          reqiredError: t('email_address') + t('_is_required'),
          regexError: t('email_address') + t('_is_invalid')
        }
      }
      validationObject["bulk_learner_phone_code"] = {
        key: 'bulk_learner_phone_code',
        required: bulkConfigs.phone_mandatory == "1",
        regex: regularExpressions.phone_code,
        reqiredError: t('required'),
        regexError: t('invalid')
      };
      validationObject["bulk_learner_phone"] = {
        key: 'bulk_learner_phone',
        required: bulkConfigs.phone_mandatory == "1",
        regex: regularExpressions.phone,
        reqiredError: t('phone_number') + t('_is_required'),
        regexError: t('phone_number') + t('_is_invalid')
      };
      Object.keys(bulkConfigs.fields).length > 0 && Object.keys(bulkConfigs.fields).map((key, index) => {
        const currentItem = bulkConfigs.fields[key];
        validationObject[key] = { key: key, required: currentItem.required, regex: null, reqiredError: t(currentItem.label) + t('_is_required'), regexError: "" }
      });
      if (hasPps) {
        validationObject['bulk_pps_number'] = {key: 'bulk_pps_number', required: true, regex: null, reqiredError: t('pps_number') + t('_is_required'), regexError: "" }
      } else {
        validationObject = {
          ...validationObject,
          bulk_pps_full_name: {
            key: "bulk_pps_full_name",
            required: !bulk_info_unavailable,
            regex: null,
            reqiredError: t('full_name') + t('_is_required'),
            regexError: ""
          },
          bulk_pps_dob: {
            key: "bulk_pps_dob",
            required: !bulk_info_unavailable,
            regex: null,
            reqiredError: t('dob') + t('_is_required'),
            regexError: ""
          },
          bulk_pps_country: {
            key: "bulk_pps_country",
            required: !bulk_info_unavailable,
            regex: null,
            reqiredError: t('country') + t('_is_required'),
            regexError: ""
          },
          bulk_pps_insurance_num: {
            key: "bulk_pps_insurance_num",
            required: !bulk_info_unavailable,
            regex: null,
            reqiredError: t('insurance_number') + t('_is_required'),
            regexError: ""
          },
          bulk_pps_address: {
            key: "bulk_pps_address",
            required: !bulk_info_unavailable,
            regex: null,
            reqiredError: t('address') + t('_is_required'),
            regexError: ""
          },
          bulk_pps_contractor_full_name: {
            key: "bulk_pps_contractor_full_name",
            required: !bulk_info_unavailable,
            regex: null,
            reqiredError: `${t('contractor')} ${t('full_name') + t('_is_required')}`,
            regexError: ""
          },
          bulk_pps_contractor_email: {
            key: "bulk_pps_contractor_email",
            required: !bulk_info_unavailable,
            regex: regularExpressions.email,
            reqiredError: `${t('contractor')} ${t('email_address') + t('_is_required')}`,
            regexError: `${t('contractor')} ${t('email_address') + t('_is_invalid')}`
          },
          bulk_pps_contractor_address: {
            key: "bulk_pps_contractor_address",
            required: !bulk_info_unavailable,
            regex: null,
            reqiredError: `${t('contractor')} ${t('address') + t('_is_required')}`,
            regexError: ""
          },
          bulk_pps_contractor_location: {
            key: "bulk_pps_contractor_location",
            required: !bulk_info_unavailable,
            regex: null,
            reqiredError: `${t('contractor')} ${t('site_location') + t('_is_required')}`,
            regexError: ""
          }
        }
      }
      Object.values(validationObject).map(item => {
        const currentElement = document.getElementById(item.key);
        if (currentElement) {
          const currentElementValue = currentElement.value.trim();
          let currentErrorStatus = false;
          let currentErrorMessage = false;
          if (item.required && currentElementValue === "") {
            currentErrorMessage = item.reqiredError;
            currentErrorStatus = true;
            mainErrorStatus = true;
          }
          if (item.regex && currentElementValue !== "" && !item.regex.test(currentElementValue)) {
            currentErrorMessage = item.regexError;
            currentErrorStatus = true;
            mainErrorStatus = true;
          }
          const dropDownElement = document.querySelector(`.custom_drop_down_value_${item.key}+.dropdown-select #floatingSelection`)
          if (currentErrorStatus) {
              currentElement.classList.add("error-border");
              currentElement.removeAttribute("readonly");
              dropDownElement && dropDownElement.classList.add("error-border");
              localValidationState[item.key] = currentErrorMessage;
              mainErrorStatus = true;
          } else{
            currentElement.classList.remove("error-border");
            dropDownElement && dropDownElement.classList.remove("error-border");
            delete localValidationState[item.key];
          }
        }
      })
      if (miscellaneous.bulk_purchase && !mainErrorStatus && Object.keys(totalLearnersList).length > 0 ) {
        let currentTotalLearnersList = { ...totalLearnersList };
        if (editingLearnerKey) {
          delete currentTotalLearnersList[editingLearnerKey];
        }
        let addOnValidationState = {};
        let currentFilledPhoneNum = (document.getElementById("bulk_learner_phone_code").value + document.getElementById("bulk_learner_phone").value).replace("+", "");
        let currentFilledEmail = document.getElementById("bulk_learner_email").value.toLowerCase();
        Object.values(currentTotalLearnersList).forEach(currentListValue => {
          if (currentListValue.bulk_learner_email.toLowerCase() == currentFilledEmail) {
            addOnValidationState["bulk_learner_email"] = t('email_already_exists');
          }
          if (currentFilledPhoneNum != "" && (currentListValue.bulk_learner_phone_code + currentListValue.bulk_learner_phone).replace("+", "") == currentFilledPhoneNum) {
            addOnValidationState["bulk_learner_phone"] = t('phone_already_exists');
          }
        });
        Object.keys(addOnValidationState).forEach(currentElementValidation => {
          document.getElementById(currentElementValidation).classList.add("error-border");
          mainErrorStatus = true;
        })
        if (Object.keys(addOnValidationState).length > 0) {
          localValidationState = { ...localValidationState, ...addOnValidationState };
        }
      }
      if (document.getElementById("bulk_learner_consent") && !document.getElementById("bulk_learner_consent").checked) {
        mainErrorStatus = true;
        localValidationState["bulk_learner_consent"] = t('check_box_required');
      } else {
        delete localValidationState["bulk_learner_consent"];
      }
      setValidated(true);
      setValidationState(localValidationState);
      if (mainErrorStatus) {
        const errorKey = Object.keys(localValidationState)[0];
        document.getElementById(errorKey) && document.getElementById(errorKey).parentElement.scrollIntoView({ behavior: "smooth" });
        return false;
      }
      addToLearnerList();
    }, 10);
  }

  useEffect(() => {
    setCurrentLearnerDetails(state => {
      let currentLearnerState = { ...state };
      currentLearnerState["hasPps"] = hasPps;
      if (hasPps == false) {
        currentLearnerState["bulk_pps_number"] = "";
      }
      return currentLearnerState;
    })
  }, [hasPps])

  useEffect(() => {
    if (currentLearnerDetails.formReset) {
      setCurrentLearnerDetails(state => {
        let currentLearnerObject = { ...state };
        delete currentLearnerObject["formReset"];
        return currentLearnerObject;
      });
      formReset(currentLearnerDetails.formReset);
    }
  }, [currentLearnerDetails]);
  
  const convertFormDataToJSON = (formData) => {
    let input = {};
    for (let [key, value] of formData.entries()) {
      input[key] = value;
    }
    const output = {};
    for (const key in input) {
      const value = input[key];
      const keys = key
        .replace(/\]/g, '')
        .split(/\[|\]/)
        .filter(Boolean);
      let current = output;
      for (let i = 0; i < keys.length; i++) {
        const isLastKey = i === keys.length - 1;
        const key = keys[i];
        if (!current[key]) {
          current[key] = isLastKey ? value : {};
        }
        current = current[key];
      }
    }
    return output;
  }

  const addToLearnerList = async () => {
    let jsonLearnerObject = convertFormDataToJSON(new FormData(document.querySelector(".bulk-learner-modal .modal-body form")));
    let innerLearner = jsonLearnerObject["learner"];
    
    let orgId = innerLearner["_dynamic"]["bulk_organisation"];
    let orgName = innerLearner["_dynamic"]["bulk_organisation_name"];
    if (document.getElementById("bulk_organisation") && innerLearner["_dynamic"]["bulk_organisation"]) {
      innerLearner["_dynamic"]["organisation_id"] = innerLearner["_dynamic"]["bulk_organisation"];
      delete innerLearner["_dynamic"]["bulk_organisation"];
    }
    delete jsonLearnerObject["learner"];
    delete jsonLearnerObject["item_type"];
    delete jsonLearnerObject["item_id"];
    delete jsonLearnerObject["bulk_learner_consent"];
    delete jsonLearnerObject["id"];
    jsonLearnerObject = { ...jsonLearnerObject, ...innerLearner };
    jsonLearnerObject["pps_info_unavailable"] = bulk_info_unavailable === true;
    
    const currentLearner = {
      ...currentLearnerDetails,
      jsonLearnerObject,
      ...(orgId && orgName ? {
        bulk_organisation: {
          name: orgName,
          value: orgId
        }
      } : {})
    };
    
    let formData = new FormData(document.querySelector(".bulk_enroll_modal:not(.place_order) form"));
    fetch("/cart_react/validate_learner", {
      method: "POST",
      body: formData
    }).then(res => res.json()).then(response => {
      // bulk_learner_email missing need to do
      if (response.error) {
        setServerErrorShowAddLearner(response.message);
        document.getElementById("bulk_learner_email") && document.getElementById("bulk_learner_email").parentElement.scrollIntoView({ behavior: "smooth" });
        return false
      }
      let currentFilledPhoneNum = (document.getElementById("bulk_learner_phone_code").value + document.getElementById("bulk_learner_phone").value).replace("+", "");
      currentFilledPhoneNum != "" ? addLearnerFinal(currentLearner) : addLearnerPostFinal(currentLearner);
    })
  }

  const addLearnerFinal = async (currentLearner) => {
    let formData = new FormData();
    formData.append('id', document.getElementById("user_id")?.value);
    formData.append('phone', document.getElementById("bulk_learner_phone")?.value);
    formData.append('country_code', document.getElementById("bulk_learner_phone_code")?.value);
    fetch("/api/front_end/check_learner_exists", {
      method: "POST",
      body: formData
    }).then(res => res.json()).then(response => {
      if (response.error) {
        setServerErrorShowAddLearnerMobile(response.message);
        document.getElementById("bulk_learner_phone") && document.getElementById("bulk_learner_phone").parentElement.scrollIntoView({ behavior: "smooth" });
        return false;
      }
      addLearnerPostFinal(currentLearner);
    });
  }

  const addLearnerPostFinal = (currentLearner) => {
    setTotalLearnersList(state => {
      const newKey = btoa(currentLearner.bulk_learner_email).replace(/^([^=]+)(=+)$/g, '$1');
      state[editingLearnerKey ? editingLearnerKey : newKey] = currentLearner;
      if (editingLearnerKey) {
        setToast({ error: false, message: t('learner_updated_successfully') });
      }
      setEditingLearnerKey(false);
      return state;
    });
    setPlaceOrderButtonDisabled(false);
    if (miscellaneous.bulk_purchase) {
      setModalShow(false);
    } else {
      setTimeout(() => {
        submitOrder();
      }, 500);
    }
  }

  const placeOrder = () => {
    setValidatedPlaceOrder(false);
    setTimeout(() => {
      let mainErrorStatus = false;
      let validationObject = {
        guest_learner_name: {
          key: 'guest_learner_name',
          required: true,
          regex: null,
          reqiredError: t('full_name') + t('_is_required'),
          regexError: ""
        },
        guest_learner_email: {
          key: 'guest_learner_email',
          required: true,
          regex: regularExpressions.email,
          reqiredError: t('email_address') + t('_is_required'),
          regexError: t('email_address') + t('_is_invalid')
        },
        guest_learner_phone: {
          key: 'guest_learner_phone',
          required: true,
          regex: regularExpressions.phone_with_optional_code,
          reqiredError: t('phone_number') + t('_is_required'),
          regexError: t('phone_number') + t('_is_invalid')
        }
      }
  
      Object.values(validationObject).map(item => {
        const currentElement = document.getElementById(item.key);
        if (currentElement) {
          const currentElementValue = currentElement.value.trim();
          let currentErrorStatus = false;
          let currentErrorMessage = false;
          if (item.required && currentElementValue === "") {
            currentErrorMessage = item.reqiredError;
            currentErrorStatus = true;
            mainErrorStatus = true;
          }
          if (item.regex && currentElementValue !== "" && !item.regex.test(currentElementValue)) {
            currentErrorMessage = item.regexError;
            currentErrorStatus = true;
            mainErrorStatus = true;
          }
          if (currentErrorStatus) {
            setValidationStatePlaceOrder(state => {
              currentElement.classList.add("error-border");
              state[item.key] = currentErrorMessage;
              mainErrorStatus = true;
              return state;
            })
          } else {
            setValidationStatePlaceOrder(state => {
              currentElement.classList.remove("error-border");
              delete state[item.key];
              return state;
            })
          }
        }
      });
  
      setValidatedPlaceOrder(true);
  
      if (mainErrorStatus) {
        const errorKey = Object.keys(validationStatePlaceOrder)[0];
        document.getElementById(errorKey) && document.getElementById(errorKey).parentElement.scrollIntoView({ behavior: "smooth" });
      } else {
        submitOrder();
      }
    }, 10);
  }

  const basicLearnerDataStructure = {
    name: {
      key: "name",
      value: "bulk_learner_name"
    },
    email: {
      key: "email",
      value: "bulk_learner_email"
    },
    phone: {
      key: "phone",
      value: "bulk_learner_phone"
    },
    country_code: {
      key: "country_code",
      value: "bulk_learner_phone_code"
    },
    organisation_id: {
      key: "organisation_id",
      value: ""
    },
    _dynamic: {
      key: "_dynamic",
      value: "_dynamic"
    },
    has_pps: {
      key: "has_pps",
      value: "hasPps"
    },
    pps_number: {
      key: "pps_number",
      value: "bulk_pps_number"
    },
    pps_info_unavailable: {
      key: "pps_info_unavailable",
      value: "pps_info_unavailable"
    },
    pps_full_name: {
      key: "pps_full_name",
      value: "bulk_pps_full_name"
    },
    pps_dob: {
      key: "pps_dob",
      value: "bulk_pps_dob"
    },
    pps_country: {
      key: "pps_country",
      value: "bulk_pps_country"
    },
    pps_insurance_num: {
      key: "pps_insurance_num",
      value: "bulk_pps_insurance_num"
    },
    pps_address: {
      key: "pps_address",
      value: "bulk_pps_address"
    },
    pps_contractor_full_name: {
      key: "pps_contractor_full_name",
      value: "bulk_pps_contractor_full_name"
    },
    pps_contractor_email: {
      key: "pps_contractor_email",
      value: "bulk_pps_contractor_email"
    },
    pps_contractor_address: {
      key: "pps_contractor_address",
      value: "bulk_pps_contractor_address"
    },
    pps_contractor_location: {
      key: "pps_contractor_location",
      value: "bulk_pps_contractor_location"
    },
  }

  const submitOrder = () => {
    setPlaceOrderButtonDisabled(true);
    setActionButtonDisabled(true);
    let formData = new FormData();
    let postingLearnerStructure = {};
    let lastPostedLearner = {};
    Object.keys(totalLearnersList).map(learnerKey => {
      let currenPostingLearner = { ...totalLearnersList[learnerKey]['jsonLearnerObject'] };
      Object.values(basicLearnerDataStructure).map(structure => {
        const currenPostingValue = totalLearnersList[learnerKey][structure.value];
        if(typeof currenPostingLearner[structure.key] === 'undefined') currenPostingLearner[structure.key] = currenPostingValue ? currenPostingValue : ""
      });
      if (currenPostingLearner["_dynamic"]["organisation_id"]) {
        currenPostingLearner["organisation_id"] = currenPostingLearner["_dynamic"]["organisation_id"];
        const orgObject = {...totalLearnersList[learnerKey]["bulk_organisation"]};
        currenPostingLearner["_dynamic"]["organisation"] = orgObject["name"];
      }
      postingLearnerStructure[learnerKey] = currenPostingLearner;
      lastPostedLearner = currenPostingLearner;
    });
    formData.append('learners', JSON.stringify(postingLearnerStructure));
    formData.append('booking_status', isWaitingList ? 2 : 1);
    formData.append('buynow', `${type}_${id}`);
    formData.append('selectedEventIds',JSON.stringify(selectedEventIds));

    if (miscellaneous.bulk_purchase) {
      if (loggedInUser) {
        formData.append("user", JSON.stringify({
          name: loggedInUser.us_name,
          email: loggedInUser.us_email,
          phone: loggedInUser.us_phone
        }));
      } else {
        formData.append("user", JSON.stringify({
          name: document.getElementById("guest_learner_name").value,
          email: document.getElementById("guest_learner_email").value,
          phone: document.getElementById("guest_learner_phone").value
        }));
      }
      formData.append('is_bulk_enroll', miscellaneous.bulk_purchase);
    } else {
      formData.append("user", JSON.stringify(lastPostedLearner));
    }
    formData.append('is_post_from_front_end_react', true);
    fetch(`/cart_react/store?buynow=${type}_${id}&api=true`, {
      method: "POST",
      body: formData
    }).then(res => res.json()).then(response => {
      if (response.status) {
        setModalShow(false);
        setOrderModalShow(false);
        setSubscriptionSuccessModalShow(true);
        return;
      }
      setModalShow(false);
      setOrderModalShow(false);
      setPlaceOrderButtonDisabled(false);
      setActionButtonDisabled(false);
      setSubscriptionErrorMessage(response.message ? response.message : t('something_went_wrong'));
    })
  }

  const purchaseNow = () => {
    setValidatedPlaceOrder(false);
    if (!loggedInUser) {
      setOrderModalShow(true);
      return;
    }
    submitOrder();
  }

  const showAddLearnerPopUp = (onload = false) => {
    setDefaultCountryCode();
    setServerErrorShowAddLearner(false);
    setServerErrorShowAddLearnerMobile(false);
    setCurrentLearnerDetails({
      hasPps: true,
      bulk_info_unavailable: false
    });
    setModalShow(true);
    setValidated(false);
    setHasPps(true);
    setBulkInfoUnavailable(false);
    setValidatedPlaceOrder(false);
    setEditingLearnerKey(false);
    if (!miscellaneous.bulk_purchase) {
      getLearnerDetails(loggedInUser.us_email, onload);
    }
  }

  useEffect(() => {
    const toaster = document.querySelector(".bulk-toaster");
    if (!toaster) return;
    if (!toast) {
      toaster.classList.remove("bulk-show");
      return;
    } 
    toaster.classList.add("bulk-show");
    setTimeout(() => {
      toaster.classList.remove("bulk-show");
    }, 3000);
  }, [toast])


  const setDefaultCountryCode = () => {
    if (typeof window["geoplugin_countryCode"] !== 'function') {
      setTimeout(() => {
        setDefaultCountryCode();
      }, 50);
      return false;
    }
    const countryCode = window["geoplugin_countryCode"]();
    let value = countryCodeList[countryCode];
    value = typeof value === "undefined" ? "+353" : value.code;
    setCurrentCountryCode(value);
  }

  const setInputDisabled = (field) => {
    if (document.querySelector(`#${field}`)) {
      document.querySelector(`#${field}`).setAttribute('readonly', true);
      return;
    }
    setTimeout(() => {
      setInputDisabled(field);
    }, 200);
  }

  const editLearner = (currentKey) => {
    setActionButtonDisabled(false);
    setEditingLearnerKey(currentKey);
    setServerErrorShowAddLearner(false);
    setServerErrorShowAddLearnerMobile(false);
    setHasPps(true);
    setBulkInfoUnavailable(false);
    setValidated(false);
    let learner = totalLearnersList[currentKey];
    let currentLearnerObject = { ...learner };

    if (learner.jsonLearnerObject) {
      const json = learner.jsonLearnerObject;
      currentLearnerObject["bulk_learner_name"] = json.name || "";
      currentLearnerObject["bulk_learner_email"] = json.email || "";
      currentLearnerObject["bulk_learner_phone"] = json.phone || "";
      if (json._dynamic) {
        currentLearnerObject["_dynamic"] = { ...json._dynamic };
          Object.entries(json._dynamic).forEach(([key, val]) => {
          if (key === "organisation_id") {
            const orgName = json._dynamic["organisation"] || "";
            currentLearnerObject["bulk_organisation"] = {
              name: orgName,
              value: val
            };
          } else {
            currentLearnerObject[key] = val || "";
          }
        });
      }
    }
    currentLearnerObject.disabledFields && currentLearnerObject.disabledFields.map(disabledFieldId => {
      setInputDisabled(disabledFieldId);
    });
    setHasPps(currentLearnerObject["hasPps"] ? true : false);
    setBulkInfoUnavailable(currentLearnerObject["bulk_info_unavailable"] ? true : false);
    setModalShow(true);
    setCurrentLearnerDetails(currentLearnerObject);
  }

  const deleteLearner = (currentKey) => {
    setTotalLearnersList(state => {
      let currentState = { ...state };
      if (currentState[currentKey]) {
        delete currentState[currentKey];
      }
      return currentState;
    });
  }

  const purchaseSuccessRedirect = () => {
    window.location.href = bulkConfigs.after_purchase_redirect.replace('{course_id}', id);
  }

  const formReset = (formId) => {
    document.querySelectorAll(`#${formId} input:not(#bulk_learner_email)`).forEach(elem => {
      elem.removeAttribute("value");
      elem.value = "";
      elem.removeAttribute("readonly");
    })
  }

  const toggleItemList = () => {
    setShowItemList(prev => !prev);
  };

  const handleEventChange = (courseId, eventId) => {
    const selectedEvent = currentCourse.c_training_course_events.find(
      event => event.id === eventId
    );
    setSelectedEventIds((prevState) => {
      const updatedSelection = prevState.filter((id) => id !== eventId);
      return [...updatedSelection, eventId];
    });

    setSelectedEventDetails(prev => ({
      ...prev,
      [courseId]: selectedEvent
    }));
    setOpenDropdownCourseId(null);
  };

  const getSelectedEventId = (courseId) => {
    const selected = selectedEventIds.find(item => item.courseId === courseId);
    return selected ? selected.eventId : '';
  };
  const handleToggleDropdown = (courseId) => {
    setOpenDropdownCourseId((prevId) => (prevId === courseId ? null : courseId));
  };

  useEffect(() => {
    if (Object.keys(totalLearnersList).length < 1) {
      setActionButtonDisabled(true);
      setPlaceOrderButtonDisabled(true);
    }
  }, [totalLearnersList])

  if (!bulkConfigs || !currentCourse) {
    return false;
  }
  return (
    <>
      <section className="cart-section py-4">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="col-md-6" style={{margin: 'auto', float: 'none'}}>
                <div className="d-flex align-center justify-content-between  w-100 mb-1 mt-25">
                  <h3>{isWaitingList ? t('add_learners_to_waiting_list') : t('enroll_learners')}</h3>
                </div>
                <div className="cart-box bulk-box waiting-list-box enroll-box">
                  <div className="d-flex">
                    <div className="cart-img">
                      <img src={currentCourse.item_full_image} onError={({ currentTarget }) => {
                        if (!currentTarget.getAttribute("errored")) {
                          currentTarget.setAttribute("errored", '1');
                          currentTarget.src = currentCourse.item_full_default_path;
                        }
                      }} />
                    </div>
                    <div className="cart-txtbar">
                      <div className="cart-text w-100">
                        {currentCourse.item_is_free == "1" && <div className="cart-price"><b>{t(currentCourse.item_free_label)}</b></div>}
                        <h5>{currentCourse.item_name}</h5>
                        <div className="d-flex cart_purchase_info">
                          {
                            ["booking_event"].includes(type) ? <>
                              <span id="bulk_event_date">
                                {clockIcon}
                                {currentCourse.item_time_text}
                              </span>
                              <span id="bulk_event_venue">
                                {currentCourse.item_tag_type == "single-live" ? rssIcon : (currentCourse.item_tag_type == "multiple" ? multipleSessionIcon : geoMarkIcon)}
                                {currentCourse.item_tag}
                              </span>
                            </> : <>
                              { currentCourse.item_course_count > 0 && `${currentCourse.item_course_count} course${currentCourse.item_course_count > 1 ? 's' : ''}`}, {currentCourse.item_training_courses_count > 0 && `${currentCourse.item_training_courses_count} training course${currentCourse.item_training_courses_count > 1 ? 's' : ''}`}, {currentCourse.item_training_events_count > 0 && `${currentCourse.item_training_events_count} event${currentCourse.item_training_events_count > 1 ? 's' : ''}`}
                            </>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="learner-action-list">
                  {type == 'bundle' &&
                      <span className="btn-items-included" onClick={toggleItemList} >
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-calendar-event" viewBox="0 0 16 16"><path d="M11 6.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5z"></path><path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z"></path></svg>
                          {currentCourse.item_training_courses_count + currentCourse.item_training_events_count + currentCourse.item_course_count} Item(s) Included 
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-down" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"></path></svg>
                      </span>
                  }
                  </div>
                  {showItemList && (
                    <div className="ect-items-wrapper">
                      <h1 className="ect-items-heading">Item(s)</h1>
                    <div className="ect-items-list">
                      <div className="row">
                      {currentCourse.c_courses.map((course) => (
                        <div key={course.id} className="training-card col-xl-6 ect-item-wrapper">
                          <div className="img-item-wrapper p-relative">
                            <span className="badge block-type">Course</span>
                            <img src={`${paths.course_path}${course?.imageUrl}`} onError={({ currentTarget }) => {
                              if (!currentTarget.getAttribute("errored")) {
                                currentTarget.setAttribute("errored", '1');
                                currentTarget.src = currentCourse.item_full_default_path;
                              }
                            }} alt="Course" />
                          </div>
                          <div className="training-details">
                            <h4>{course.course_name}</h4>
                          </div>
                        </div>
                      ))}
                      {currentCourse.c_training_courses.map((course) => {
                            const courseEvents = currentCourse.c_training_course_events.filter(event => event.bce_course_id === course.id);
                            return (
                              <div key={course.id} className="training-card col-xl-6 ect-item-wrapper">
                                <div className="img-item-wrapper p-relative">
                                <span className="badge block-type">Training</span>
                                <img src={`${paths.event_path}${course?.imageUrl}`} onError={({ currentTarget }) => {
                                  if (!currentTarget.getAttribute("errored")) {
                                    currentTarget.setAttribute("errored", '1');
                                    currentTarget.src = currentCourse.item_full_default_path;
                                  }
                                }} alt="Training" />
                                </div>
                                <div className="training-details">
                                  <h4>{course.training_course_name}</h4>
                                  <div className={`myk-dropdown-container`} >
                                    {courseEvents.length > 0 ? (
                                      <div className="myk-dropdown-input" onClick={() => handleToggleDropdown(course.id)}>
                                        <input
                                          type="text"
                                          readOnly
                                          value={
                                            selectedEventDetails[course.id]
                                              ? `${selectedEventDetails[course.id].bce_code} (${selectedEventDetails[course.id].bce_name})`
                                              : ''
                                          }                                          
                                          placeholder="Select Training Event"
                                          className={`myk-dropdown-placeholder ${getSelectedEventId(course.id) ? 'filled' : ''}`}
                                        />
                                        <label>Select Training Event</label>
                                        <div className="caret-icon">
                                          <svg xmlns="http://www.w3.org/2000/svg" width="6.119" height="11.658" viewBox="0 0 6.119 11.658">
                                            <path id="Path_21616" data-name="Path 21616" d="M0,0,4.42,3.71,8.84,0" transform="translate(1.409 10.249) rotate(-90)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"></path>
                                          </svg>
                                        </div>
                                      </div>
                                    ) : (
                                      <span className="badge mk-badge-expired">No Events Available</span>
                                    )}

                                  {openDropdownCourseId === course.id &&(
                                      <div className="myk-custom-dropdown-menu">
                                        {courseEvents.map(event => (
                                          <div
                                            key={event.id}
                                            className="myk-custom-dropdown-item"
                                            onClick={() => handleEventChange(course.id, event.id)}
                                          >
                                            {event.bce_code} ({event.bce_name})
                                          </div>
                                        ))}
                                      </div>
                                    )}
                                    {selectedEventDetails[course.id] && (
                                      <div className="cart-training-event-desc mt-4">
                                        {selectedEventDetails[course.id] && (
                                          <div className="mb-1 icon-teacher-expiry d-flex align-items-center gap-1">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-clock"><path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"></path><path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z"></path></svg>                                            
                                            <p class="p-0 m-0 d-inline-flex gap-1 mk-flex-one">{selectedEventDetails[course.id].bce_start_date} - {selectedEventDetails[course.id].bce_end_date}</p>
                                          </div>
                                        )}
                                        {selectedEventDetails[course.id].bce_venue && (
                                          <div className="mb-1 icon-teacher-expiry d-flex align-items-center gap-1">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-geo-alt" viewBox="0 0 16 16"><path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A31.493 31.493 0 018 14.58a31.481 31.481 0 01-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0110 0c0 .862-.305 1.867-.834 2.94zM8 16s6-5.686 6-10A6 6 0 002 6c0 4.314 6 10 6 10z"></path><path d="M8 8a2 2 0 110-4 2 2 0 010 4zm0 1a3 3 0 100-6 3 3 0 000 6z"></path></svg>
                                            <p class="p-0 m-0 d-inline-flex gap-1 mk-flex-one">{selectedEventDetails[course.id].bce_venue}</p>
                                          </div>
                                        )}
                                        {selectedEventDetails[course.id] && (
                                          <span className="badge mk-badge-expired">
                                            {selectedEventDetails[course.id].bce_maximum_registration_limit - selectedEventDetails[course.id].bce_total_registrations} seats left
                                          </span>
                                        )}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            );
                          })}

                          {currentCourse.c_training_events.map((event) => (
                            <div key={event.id} className="training-card col-xl-6 ect-item-wrapper">
                              <div className="img-item-wrapper p-relative">
                                <span className="badge block-type">Events</span>
                                <img src={`${paths.event_path}${event?.imageUrl}`} onError={({ currentTarget }) => {
                                  if (!currentTarget.getAttribute("errored")) {
                                    currentTarget.setAttribute("errored", '1');
                                    currentTarget.src = currentCourse.item_full_default_path;
                                  }
                                }} alt="Event" />
                              </div>
                              <div className="training-details">
                                <h4>{event.training_event_name}</h4>
                              </div>
                            </div>
                          ))}

                      </div>
                    </div>
                    
                    </div>
                  )}
                  <div className="cart-bulk-actions bulk-learner-list">
                    {
                      (miscellaneous.bulk_purchase || !miscellaneous.bulk_purchase && Object.keys(totalLearnersList).length < 1) && <span className="add-learner-box" id="add-bulk-learner" onClick={showAddLearnerPopUp}>{t('add_learner')}</span>
                    }
                    <div id="add_learner_list">
                      {
                        Object.keys(totalLearnersList).length > 0 && Object.keys(totalLearnersList).reverse().map(currentKey => {
                          const learner = totalLearnersList[currentKey];
                          const jsonData = learner.jsonLearnerObject || {};
                          
                          const displayName = jsonData.name || learner.bulk_learner_name;
                          const displayEmail = jsonData.email || learner.bulk_learner_email;
                          return <>
                            <div class="learner_lists bulk_page">
                              <span className="name-letter">{displayName?.substr(0, 1)}</span>
                              <span className="learner-name">{displayName}</span>
                              <span className="mail-id">{displayEmail}</span>
                              <span class="learner-list-action">
                                <span class="edit-svg" onClick={() => {editLearner(currentKey)}}>
                                  {learnerEdiIcon}
                                </span>
                                {
                                  (miscellaneous.bulk_purchase || !miscellaneous.bulk_purchase && Object.keys(totalLearnersList).length < 1) &&
                                  <span class="icon-trash-empty bulk-page" onClick={() => {deleteLearner(currentKey)}}>
                                    {learnerTrashIcon}
                                  </span>
                                }
                              </span>
                            </div>
                          </>
                        })
                      }
                    </div>
                    {
                      miscellaneous.bulk_purchase && <button className="btn done-btn theme-blue-btn1" id="bulk_enroll_btn" disabled={placeOrderButtonDisabled} onClick={purchaseNow}>{t(currentCourse.item_free_button)}</button>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {
        toast && 
        <div class="bulk-toaster">
          <div className={"content" + (toast.error ? " error" : "")}>
            {toast.message}
          </div>
        </div>
      }
      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size=""
        aria-labelledby="contained-modal-title-vcenter"
        centered
        contentClassName="bg-white p-0 bulk-learner-modal"
        className="bulk-modal bulk_enroll_modal"
        backdrop={false}
      >
        <Modal.Header className="except-modal-header">
          <span className="bulk-modal-close" onClick={() => setModalShow(false)}>{closeIcon}</span>
          <h3 className="text-bold">{t('add_learner')}</h3>
          <p>{t('add_learner_popup_subtitle')}</p>
        </Modal.Header>
        <Modal.Body className="text-left pt-0">
          <Form id="addLearnerForm" className="mt-4" autoComplete="off">
            <input type="hidden" name="id" id="user_id" value={ currentLearnerDetails["user_id"] }/>
            <div className="row">
              <div className="col-md-6 float-label-input">
                <input type="text" className="form-control" name="learner[name]" id="bulk_learner_name" onInput={customInput} value={ currentLearnerDetails["bulk_learner_name"] } />
                <label htmlFor="bulk_learner_name">{t('first_and_last_name')} *</label>
                <ErrorMessage id="bulk_learner_name" />
              </div>
              <div className="col-md-6 float-label-input">
                <input type="email" className="form-control" name="learner[email]" id="bulk_learner_email" onInput={customInput} value={ currentLearnerDetails["bulk_learner_email"] } />
                <label htmlFor="bulk_learner_email">{t('email_address')} *</label>
                <ErrorMessage id="bulk_learner_email" />
                <ServerErrorOnAddLearnerEmail />
              </div>
              <div className="col-sm-4 col-md-2 float-label-input mt-3">
                <input type="tel" className="form-control" name="learner[country_code]" id="bulk_learner_phone_code" onInput={customInput} value={currentCountryCode} />
                <label htmlFor="bulk_learner_phone_code">{t('code') + (bulkConfigs.phone_mandatory == "1" ? " *" : "") }</label>
                <ErrorMessage id="bulk_learner_phone_code" />
              </div>
              <div className="col-sm-8 col-md-4 float-label-input mt-3">
                <input type="tel" className="form-control" name="learner[phone]" id="bulk_learner_phone" onInput={customInput} value={ currentLearnerDetails["bulk_learner_phone"] } />
                <label htmlFor="bulk_learner_phone">{t('phone_number') + (bulkConfigs.phone_mandatory == "1" ? " *" : "") }</label>
                <ErrorMessage id="bulk_learner_phone" />
                <ServerErrorOnAddLearnerMobile />
              </div>
              {
                Object.keys(bulkConfigs.fields).length > 0 && Object.keys(bulkConfigs.fields).map((key, index) => {
                  const currentItem = bulkConfigs.fields[key];
                  switch (currentItem.type) {
                    case 'text':
                      return (<div key={`input_${key}`} className="col-md-6 float-label-input mt-3">
                        <input type="text" className="form-control" name={`learner[_dynamic][${key}]`} id={key} onInput={customInput} value={ currentLearnerDetails[key] } />
                        <label htmlFor={key}>{`${currentItem.label}${currentItem.required ? " *" : ""}`}</label>
                        <HelpText id={key} helpText={currentItem.purpose ? t(currentItem.purpose) : ""} />
                        <ErrorMessage id={key} />
                      </div>);
                    case 'dropdown':
                      return (<div key={`input_${key}`} className="col-md-6 mt-3">
                        <input type="hidden" name={`learner[_dynamic][${key}]`} id={key} className={"custom_drop_down_value_" + key} tabIndex={-1} value={ currentLearnerDetails[key]?.value } />
                        <input type="hidden" name={`learner[_dynamic][${key}_name]`} id={`${key}_name`} value={currentLearnerDetails[key]?.name} />
                        <DropdownCommon items={currentItem.range} label={`${t(currentItem.label)}${currentItem.required ? " *" : ""}`} onChange={(obj) => customInputChange(key, obj)} className="mb-0" defaultValue={currentLearnerDetails[key] ? currentLearnerDetails[key] : {name: "", value: ""}} autoComplete="off" />
                        <HelpText id={key} helpText={currentItem.purpose ? t(currentItem.purpose) : ""} />
                        <ErrorMessage id={key} />
                      </div>);
                    default:break;
                  }
                })
              }
              {
                currentCourse.item_is_pps_required == 1 && <>
                  <div className="col-md-12 mt-3 dev-pps-block">
                    <span className="coupon-subtxt m-0">{t('do_you_have_pps')}</span>
                    <div className="d-flex mt-05 ppc-choose">
                      <span className="yes-pps-sec">
                        <input type="hidden" value={hasPps} name="hasPps" id="hasPps" />
                        <label htmlFor="bulk_pps_yes" className="px-2">
                          <input type="radio" id="bulk_pps_yes" className="pps_radio_new" name="learner[has_pps]" defaultValue={1} checked={hasPps} onClick={() => setHasPps(true)} />
                          &nbsp;&nbsp;{t('yes')}
                        </label>
                      </span>
                      <span className="no-ppc-sec">
                        <label htmlFor="bulk_pps_no" className="px-2">
                          <input type="radio" id="bulk_pps_no" className="pps_radio_new" defaultValue={0} name="learner[has_pps]" checked={!hasPps} onClick={() => setHasPps(false)} />
                          &nbsp;&nbsp;{t('no')}
                        </label>
                      </span>
                    </div>
                  </div>
                  {
                    hasPps ? <>
                      <div className="mt-2 dev-pps-block" id="pps_number_form_bulk">
                        <div className="col-md-9 pl-0 pr-2 float-label-input form-group-alter">
                          <input type="text" id="bulk_pps_number" name="learner[pps_number]" maxLength={20} className="form-control form-alter" onInput={customInput} value={ currentLearnerDetails["bulk_pps_number"] }  />
                          <label className htmlFor="bulk_pps_number">{t('pps_number')} *</label>
                          <ErrorMessage id="bulk_pps_number" />
                        </div>
                      </div>
                    </> : <>
                      <div className="mt-05 dev-pps-block" id="pps_detailed_form_bulk">
                          <span className="coupon-subtxt">{t('enter_stb_form')}</span>
                        <span className="info-checkbox">
                            <input type="checkbox" name="learner[pps_info_unavailable]" id="bulk_info_unavailable" onClick={(e) => {
                              setBulkInfoUnavailable(e.target.checked);
                              setCurrentLearnerDetails(state => {
                                let currentLearnerState = { ...state };
                                currentLearnerState['bulk_info_unavailable'] = e.target.checked
                                return currentLearnerState;
                              })
                            }} checked={bulk_info_unavailable} />
                          {t('information_unavailable')}
                        </span>
                        <span className="cart-sub-text">{t('candidate_details')}</span>
                        <div className="row">
                          <div className="col-md-6 pr-1">
                            <div className="float-label-input">
                                <input type="text" id="bulk_pps_full_name" name="learner[pps_full_name]" className="form-control" onInput={customInput} required readOnly={bulk_info_unavailable} defaultValue={ currentLearnerDetails["bulk_pps_full_name"] } />
                              <label htmlFor="bulk_pps_full_name">{t('full_name')} *</label>
                              <ErrorMessage id="bulk_pps_full_name" />
                            </div>
                          </div>
                          <div className="col-md-6 pl-1 pd-sm">
                            <div className="float-label-input">
                              <input type="date" id="bulk_pps_dob" name="learner[pps_dob]" className="form-control" onInput={customInput} required readOnly={bulk_info_unavailable} defaultValue={ currentLearnerDetails["bulk_pps_dob"] ? currentLearnerDetails["bulk_pps_dob"] : " " } />
                              <label className=" date-label" htmlFor="bulk_pps_dob">{t('dob')} *</label>
                              <ErrorMessage id="bulk_pps_dob" />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6 pr-1 mt-3">
                            <div>
                              <input type="hidden" name="learner[pps_country]" id="bulk_pps_country" className="custom_drop_down_value_bulk_pps_country" readOnly={bulk_info_unavailable} defaultValue={ currentLearnerDetails["bulk_pps_country"]?.value } />
                              <DropdownCommon items={Object.values(countryList)} label={t('select_country') + " *"} onChange={(obj) => customInputChange("bulk_pps_country", obj)} className="mb-0" defaultValue={currentLearnerDetails["bulk_pps_country"] ? currentLearnerDetails["bulk_pps_country"] : {name: "", value: ""}}  readOnly={bulk_info_unavailable} />
                              <ErrorMessage id="bulk_pps_country" />
                            </div>
                          </div>
                          <div className="col-md-6 pl-1 pd-sm mt-3">
                            <div className="float-label-input">
                              <input type="number" id="bulk_pps_insurance_num" className="form-control" onInput={customInput} required readOnly={bulk_info_unavailable} defaultValue={ currentLearnerDetails["bulk_pps_insurance_num"] } />
                              <label htmlFor="bulk_pps_insurance_num">{t('national_insurance_number')} *</label>
                              <ErrorMessage id="bulk_pps_insurance_num" />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12 mt-3">
                            <div className="float-label-input">
                              <input type="text" id="bulk_pps_address" name="learner[pps_address]" onInput={customInput} className="form-control" required readOnly={bulk_info_unavailable} defaultValue={ currentLearnerDetails["bulk_pps_address"] } />
                              <label htmlFor="bulk_pps_address">{t('address')} *</label>
                              <ErrorMessage id="bulk_pps_address" />
                            </div>
                          </div>
                        </div>
                          <span className="cart-sub-text mt-3">{t('contractor_details')}</span>
                        <div className="row">
                          <div className="col-md-6 pr-1 mt-1">
                            <div className="float-label-input">
                              <input type="text" id="bulk_pps_contractor_full_name" name="learner[pps_contractor_full_name]" onInput={customInput} className="form-control" required readOnly={bulk_info_unavailable} defaultValue={ currentLearnerDetails["bulk_pps_contractor_full_name"] } />
                              <label htmlFor="bulk_pps_contractor_full_name">{t('full_name')} *</label>
                              <ErrorMessage id="bulk_pps_contractor_full_name" />
                            </div>
                          </div>
                          <div className="col-md-6 pl-1 pd-sm mt-3 mt-md-1">
                            <div className="float-label-input">
                              <input type="text" id="bulk_pps_contractor_email" onInput={customInput} name="learner[pps_contractor_email]" className="form-control" required readOnly={bulk_info_unavailable} defaultValue={ currentLearnerDetails["bulk_pps_contractor_email"] } />
                              <label htmlFor="bulk_pps_contractor_email">{t('email_address')} *</label>
                              <ErrorMessage id="bulk_pps_contractor_email" />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12 mt-3">
                            <div className="float-label-input">
                              <input type="text" id="bulk_pps_contractor_address" onInput={customInput} name="learner[pps_contractor_address]" className="form-control" required readOnly={bulk_info_unavailable} defaultValue={ currentLearnerDetails["bulk_pps_contractor_address"] } />
                              <label htmlFor="bulk_pps_contractor_address">{t('address')} ({t('in_ireland')}) *</label>
                              <ErrorMessage id="bulk_pps_contractor_address" />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6 mt-3">
                            <div className="float-label-input">
                              <input type="text" id="bulk_pps_contractor_location" name="learner[pps_contractor_location]" onInput={customInput} className="form-control" required readOnly={bulk_info_unavailable} defaultValue={ currentLearnerDetails["bulk_pps_contractor_location"] } />
                              <label htmlFor="bulk_pps_contractor_location">{t('site_location')} ({t('in_ireland')}) *</label>
                              <ErrorMessage id="bulk_pps_contractor_location" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  }
                </>
              }
              {
                bulkConfigs.consent.learner_consent && <>
                  <div className="col-sm-12 mt-3 consent">
                    <div className="consent-request">{t(bulkConfigs.consent.purchase_concerns_request)}</div>
                    <input className="consent-checkbox" type="checkbox" id="bulk_learner_consent" name="bulk_learner_consent" defaultChecked={ editingLearnerKey !== false } />
                    <div className="consent-response">
                      {t(bulkConfigs.consent.purchase_concerns_response)}
                    </div>
                    <div className="consent-description" dangerouslySetInnerHTML={{ __html: t(bulkConfigs.consent.purchase_concerns_description) }}>
                    </div>
                    <ErrorMessage id="bulk_learner_consent" />
                  </div>
                </>
              }
            </div>
            <input type="hidden" name="item_id" defaultValue={id}/>
            <input type="hidden" name="item_type" defaultValue={type} />
          </Form>
        </Modal.Body>
        <Modal.Footer className="justify-content-end fixed">
          <Button id="actionButton" variant="primary" className="px-4" onClick={addLearner} disabled={actionButtonDisabled}>{ miscellaneous.bulk_purchase ? (editingLearnerKey ? t('update_learner') : t('add_learner')) : t(currentCourse.item_free_button)}</Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={orderModalShow}
        onHide={() => setOrderModalShow(false)}
        size=""
        aria-labelledby="contained-modal-title-vcenter"
        centered
        contentClassName="bg-white p-0 bulk-learner-modal"
        className="bulk-modal bulk_enroll_modal place_order"
        backdrop={false}
      >
        <Modal.Header className="except-modal-header">
          <span className="bulk-modal-close" onClick={() => setOrderModalShow(false)}>{closeIcon}</span>
          <h3 className="text-bold">{t('order_contact_details')}</h3>
          <p>{t('order_contact_subtitle')}</p>
        </Modal.Header>
        <Modal.Body className="text-left pt-0">
          <Form className="mt-4" autoComplete="off">
            <div className="row">
              <div className="col-md-6 float-label-input">
                <input type="text" className="form-control" name="guest_learner_name" id="guest_learner_name" onInput={customInputGuest} />
                <label htmlFor="guest_learner_name">{t('full_name')} *</label>
                <ErrorMessagePlaceOrder id="guest_learner_name" />
              </div>
              <div className="col-md-6 float-label-input">
                <input type="email" className="form-control" name="guest_learner_email" id="guest_learner_email" onInput={customInputGuest} />
                <label htmlFor="guest_learner_email">{t('email_address')} *</label>
                <ErrorMessagePlaceOrder id="guest_learner_email" />
              </div>
              <div className="col-sm-6 float-label-input mt-3">
                <input type="tel" className="form-control" name="guest_learner_phone" id="guest_learner_phone" onInput={customInputGuest} />
                <label htmlFor="guest_learner_phone">{t('phone_number')} *</label>
                <ErrorMessagePlaceOrder id="guest_learner_phone" />
              </div>
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer className="justify-content-end fixed">
          <Button variant="primary" className="px-4" onClick={placeOrder} disabled={placeOrderButtonDisabled}>{t('submit')}</Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={subscriptionSuccessModalShow}
        onHide={() => {
          setTotalLearnersList({});
          setSubscriptionSuccessModalShow(false);
          miscellaneous.bulk_purchase && window.location.reload();
        }}
        size=""
        aria-labelledby="contained-modal-title-vcenter"
        centered
        contentClassName="bg-white p-0"
        className="bulk-modal pt-200"
        backdrop={false}
      >
        <Modal.Body className="">
          <button type="button" class="close cart-close" onClick={() => {
            setSubscriptionSuccessModalShow(false);
            setTotalLearnersList({});
            miscellaneous.bulk_purchase && window.location.reload();
          }}>×</button>
          <div class="order-succes-icon mx-auto">
            { orderSuccess }
          </div>
          <h3 class="mt-1" id="subscription_succees_modal_type_text">{isWaitingList ? t('learner_enrolled_to_waiting_list') : t('enrolment_successful')}</h3>
          <p class="free_enrolled_message">{isWaitingList ? t('waiting_list_success_subtitle') : t('enrolment_sucess_subtitle')}</p>
          <button class="btn mt-2 mt-3 front_end_cart_btn theme-blue-btn1 orange-flat-btn" id="item_enroll_success_btn" onClick={purchaseSuccessRedirect}>{t('continue')}</button>
        </Modal.Body>
      </Modal>
      <Modal
        show={subscriptionErrorMessage}
        onHide={() => {
          setSubscriptionErrorMessage(false);
        }}
        size=""
        aria-labelledby="contained-modal-title-vcenter"
        centered
        contentClassName="bg-white p-0"
        className="bulk-modal pt-200"
        backdrop={false}
      >
        <Modal.Body className="">
          <div class="pps-details-sec">
            <div class="bulk-error payment_warning" style={{textAlign: "center"}}>
              <svg xmlns="http://www.w3.org/2000/svg" width="82" height="82" viewBox="0 0 82 82">
                  <g id="Ellipse_107" data-name="Ellipse 107" transform="translate(10 10)" fill="#f58484" stroke="rgba(224,136,136,0.2)" stroke-width="10">
                      <circle cx="31" cy="31" r="31" stroke="none"></circle>
                      <circle cx="31" cy="31" r="36" fill="none"></circle>
                  </g>
                  <g id="Group_7" data-name="Group 7" transform="translate(2327.5 1155)">
                      <path id="Path_82" data-name="Path 82" d="M23071.385-21816.166l6.5-6.5,10.84-10.828" transform="translate(-25366.885 20710.992)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"></path>
                      <path id="Path_82-2" data-name="Path 82" d="M23071.385-21816.166l6.5-6.5,10.84-10.828" transform="translate(-24111.666 -24193.885) rotate(90)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"></path>
                  </g>
              </svg>
              <h2>{t('oh_oh')}</h2>
              <p id="error-msg-content-seat-limit" dangerouslySetInnerHTML={{ __html: subscriptionErrorMessage }}></p>
              <div class="button-action mt-3">
                  <div class="theme-blue-btn1 btn" id="redirect_explore_btn" data-dismiss="modal" onClick={() => setSubscriptionErrorMessage(false)}>{t('review_list')}</div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
export default BulkEnroll;